import React, { Suspense } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";

import HomePage from "./pages/HomePage";
import ProtectedRoute from "./components/Authentication/ProtectedRoute";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllLiked } from "./store/likedSlice/liked-actions";
import { authActions } from "./store/authSlice/auth-slice";
import { getAllCollections } from "./store/userCollectionsSlice/collections-actions";
import Toast from "./components/Toast/Toast";

import LoadingSpinner from "./components/UI/LoadingSpinner";

const LoginPage = React.lazy(() => import("./pages/LoginPage"));
const SignupPage = React.lazy(() => import("./pages/SignupPage"));
const CollectionsPage = React.lazy(() => import("./pages/CollectionsPage"));
const SingleCollectionPage = React.lazy(() =>
  import("./pages/SingleCollectionPage")
);
const SearchResultsPage = React.lazy(() => import("./pages/SearchResultsPage"));
const SingleImagePage = React.lazy(() => import("./pages/SingleImagePage"));
const ProfilePage = React.lazy(() => import("./pages/ProfilePage"));
const UserCollectionPage = React.lazy(() =>
  import("./pages/UserCollectionPage")
);

function App() {
  const location = useLocation();
  const bgPage = location.state && location.state.background;
  const isloggedIn = useSelector((state) => state.auth.userLoggedIn);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.RetreiveAuth());
    if (isloggedIn) {
      dispatch(getAllCollections());
      dispatch(getAllLiked());
    }
  }, [dispatch, isloggedIn]);

  return (
    <>
      <Toast />
      <Suspense fallback={<LoadingSpinner />}>
        <Switch location={bgPage || location}>
          <Route path="/" exact>
            <HomePage />
          </Route>
          <Route path="/login" exact>
            <LoginPage />
          </Route>
          <Route path="/signup" exact>
            <SignupPage />
          </Route>
          <Route path="/collections" exact>
            <CollectionsPage />
          </Route>
          <Route path="/collections/:topic" exact>
            <SingleCollectionPage />
          </Route>
          <Route path="/search" exact>
            <SearchResultsPage />
          </Route>
          <ProtectedRoute path="/profile/collections/:id" exact>
            <UserCollectionPage />
          </ProtectedRoute>
          <ProtectedRoute path="/profile">
            <ProfilePage />
          </ProtectedRoute>
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
        {bgPage && (
          <Route path="/photo/:id">
            <SingleImagePage />
          </Route>
        )}
      </Suspense>
    </>
  );
}

export default App;
